export const DeleteIcon = ({ size = 24 }: { size?: number }) => {
  return (
    <>
      {size === 16 ? (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.0013 5.0013L11.6068 10.858C11.5071 12.2534 10.3459 13.3346 8.94689 13.3346H7.05572C5.65668 13.3346 4.4955 12.2534 4.39582 10.858L4.0013 5.0013M2.66797 5.33463C2.66797 5.33463 4.44575 4.66797 8.0013 4.66797C11.5569 4.66797 13.3346 5.33463 13.3346 5.33463M10.668 4.80604L10.6132 4.33917C10.4524 3.37479 9.61806 2.66797 8.64038 2.66797H7.36222C6.38454 2.66797 5.55016 3.37479 5.38943 4.33917L5.33463 4.80604M9.66797 8.0013V10.0013M6.33463 8.0013V10.0013M8.0013 7.33463L8.0013 10.668"
            stroke="#222530"
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 9.63704L15.6055 15.4937C15.5058 16.8892 14.3446 17.9704 12.9456 17.9704H11.0544C9.6554 17.9704 8.49422 16.8892 8.39454 15.4937L8.00002 9.63704M6.66669 9.97038C6.66669 9.97038 8.44446 9.30371 12 9.30371C15.5556 9.30371 17.3334 9.97038 17.3334 9.97038M14.6667 9.44178L14.6119 8.97491C14.4512 8.01054 13.6168 7.30371 12.6391 7.30371H11.3609C10.3833 7.30371 9.54888 8.01054 9.38815 8.97491L9.33335 9.44178M13.6667 12.637V14.637M10.3334 12.637V14.637M12 11.9704L12 15.3037"
            stroke="#222530"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  );
};
